module.exports = __webpack_public_path__ + "img/private-list-bg.ad61625e.png";